export default {
    namespaced: true,
    state: {
        confirmation: null,
        documents: [],
        terms: [],
        projects: [],
        roles: [],
        otherApplicantUnitLedgerEntries: [],
        documentCategories: [],
        application: null,
    },
    mutations: {
        setConfirmation: (state, confirmation) => state.confirmation = confirmation,
        setDocuments: (state, documents) => state.documents = documents,
        setApproval: (state, approvalValue) => state.confirmation.approval = approvalValue,
        setTerms: (state, terms) => state.terms = terms,
        setProjects: (state, projects) => state.projects = projects,
        setRoles: (state, roles) => state.roles = roles,
        setOtherApplicantUnitLedgerEntries: (state, value) => state.otherApplicantUnitLedgerEntries = value,
        setApplication: (state, value) => state.application = value,
        setDocumentCategories: (state, value) => state.documentCategories = value,
    },
    actions: {
        refresh({commit}, id) {
            axios.get('/api/landlord/'+id).then(r => {
                commit('setConfirmation', r.data.confirmation);
                commit('setDocuments', r.data.documents);
                commit('setTerms', r.data.terms)
                commit('setProjects', r.data.projects)
                commit('setRoles', r.data.roles)
                commit('setOtherApplicantUnitLedgerEntries', r.data.otherApplicantUles);
                commit('setDocumentCategories', r.data.documentCategories);
                commit('setApplication', r.data.application);

                const project = r.data.application.project

                commit('Project/SET_PROJECT', project, { root: true });
                commit('Project/SET_OWNER_ORGANIZATION', project ? project.owner_organization: null, { root: true });
                commit('Project/SET_MANAGER_ORGANIZATION', project? project.manager_organization: null, { root: true });
                commit('Project/SET_PAYEE_ORGANIZATION', project? project.payee_organization: null, { root: true });
                commit('Project/SET_PAYEE_ORGANIZATION_ID', project? project.payee_organization_id: null, { root: true });
            });
        },

        updateProject({commit}, param) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/api/landlord/${param.confirmation_id}/update-project`, param)
                    .then((res) => {
                        const project = res.data.application.project
                        commit('setApplication', res.data.application);

                        commit('Project/SET_PROJECT', project, { root: true });
                        commit('Project/SET_OWNER_ORGANIZATION', project ? project.owner_organization: null, { root: true });
                        commit('Project/SET_MANAGER_ORGANIZATION', project? project.manager_organization: null, { root: true });
                        commit('Project/SET_PAYEE_ORGANIZATION', project? project.payee_organization: null, { root: true });
                        commit('Project/SET_PAYEE_ORGANIZATION_ID', project? project.payee_organization_id: null, { root: true });
                        resolve(res.data)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },

        setOwnerManagerInformation({commit}, param) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/api/landlord/${param.confirmation_id}/set-owner-manager`, param)
                    .then((res) => {
                        const project = res.data.application.project
                        commit('setApplication', res.data.application);

                        commit('Project/SET_PROJECT', project, { root: true });
                        commit('Project/SET_OWNER_ORGANIZATION', project ? project.owner_organization: null, { root: true });
                        commit('Project/SET_MANAGER_ORGANIZATION', project? project.manager_organization: null, { root: true });
                        commit('Project/SET_PAYEE_ORGANIZATION', project? project.payee_organization: null, { root: true });
                        commit('Project/SET_PAYEE_ORGANIZATION_ID', project? project.payee_organization_id: null, { root: true });
                        resolve(res.data)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },
    },
    getters: {

    }
}
